import script from "./AddressDetail.vue?vue&type=script&lang=ts&setup=true"
export * from "./AddressDetail.vue?vue&type=script&lang=ts&setup=true"

import "./AddressDetail.vue?vue&type=style&index=0&id=3ad58065&scoped=true&lang=less"

import exportComponent from "D:\\work\\risfond-branchmanagementsystem\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3ad58065"]])

export default __exports__